export default __webpack_public_path__ + "static/media/about-info.53b10a9c.svg";